import { SearchFilter, SearchHistoryQueryState } from "state/search/state";

export const emptySearchFilter: SearchFilter = {
    entryType: "posting",
    ownedByMe: false,
    repliedToMe: false,
    minImageCount: null,
    videoPresent: null,
    attachmentPresent: null,
    safeSearch: null,
    beforeDate: "now",
    datePeriod: "any"
};

export const emptyHistoryQuery: SearchHistoryQueryState = {
    loading: false,
    loaded: false
}
